// Raw Firebase config used to initialise the SDK, sourced from env vars.
const firebaseRawConfig = {
  apiKey: process.env.GATSBY_FIREBASE_KEY,
  authDomain:
    process.env.GATSBY_FIREBASE_AUTH_DOMAIN ||
    `${process.env.GATSBY_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL:
    process.env.GATSBY_FIREBASE_DATABASE_URI ||
    `https://${process.env.GATSBY_FIREBASE_PROJECT_ID}.firebaseio.com`,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
  databaseId: process.env.GATSBY_FIREBASE_DATABASE_ID,
  emulator: {
    authHost: process.env.GATSBY_FIREBASE_EMULATOR_AUTH_HOST || "localhost",
    authPort: Number(process.env.GATSBY_FIREBASE_EMULATOR_AUTH_PORT) || 9099,
    firestoreHost:
      process.env.GATSBY_FIREBASE_EMULATOR_FIRESTORE_HOST || "localhost",
    firestorePort:
      Number(process.env.GATSBY_FIREBASE_EMULATOR_FIRESTORE_PORT) || 8080,
  },
};

export { firebaseRawConfig };
